import script from "./AVosKidsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AVosKidsPage.vue?vue&type=script&setup=true&lang=js"

import "./AVosKidsPage.vue?vue&type=style&index=0&id=fa0ca20a&lang=scss"

const __exports__ = script;

export default __exports__